module.exports = __webpack_public_path__ + "fonts/SeoulNamsanEB.b587e374.otf";